import { useParams } from 'react-router-dom';

import { useChainId } from '@occc-app/Chain/hooks';
import { getUpdatePageLinks, useGetCampaignName } from '@occc-app/routes/CampaignComponents/utils';
import { OfferUpdatePageContainer } from '@occc-app/offerHelpers/components/OfferUpdatePageContainer';
import { OfferType } from '@occc-app/offerValidationService/types';

import { messages } from '../../promocodes.messages';
import { PromocodesConfigurationFormContainer } from '../../components/PromocodesConfiguration';
import { getPromocodesTargetTabProps } from '../../components/PromocodesTargetConfiguration';

export const PromocodesUpdateController = () => {
  const { id: campaignId = '', promocodesId = '' } = useParams<{
    id: string;
    promocodesId: string;
  }>();
  const chainId = useChainId();
  const campaignName = useGetCampaignName(chainId, campaignId);
  const getBreadcrumbLinks = (campaignComponentName: string) =>
    getUpdatePageLinks({
      campaignId,
      campaignComponentId: promocodesId,
      campaignName,
      pageTitle: messages.configurePageTitle,
      campaignComponentName,
    });

  return (
    <OfferUpdatePageContainer
      campaignId={campaignId}
      offerId={promocodesId}
      getBreadcrumbLinks={getBreadcrumbLinks}
      pageTitle={messages.configurePageTitle}
      subtitle={messages.subtitle}
      offerType={OfferType.Promocodes}
      ConfigureFormContainer={PromocodesConfigurationFormContainer}
      targetTabProps={getPromocodesTargetTabProps}
    />
  );
};
